<template>
<div :class="['micad_formElement micad_formElement_textBoxDropdownCombo',getType(type)]">
    <label class="micad_formElement_label">{{label}}</label>
    <div class="micad_formElement_control">
        <input type="text" class="micad_formElement_control_input" value="">
       <select class="micad_formElement_control_input">
            <option value="option1">Option 1</option>
            <option value="option2">Option 2</option>
            <option value="option3">Option 3</option>
            <option value="option4">Option 4</option>
        </select>
    </div>
    <div class="micad_formElement_message">{{message}}</div>
</div>
</template>

<script>
export default {
  name: 'Text-box-dropdown-combo',
  data() {
    return {
        label: "Quisque tristique.",
        message: "Quisque tristique quis leo vitae luctus.",
        }
    },
    props: {
        type: String,
    },
    methods: {
        getType(type) {
            if (type !== undefined) {
                return ' micad_formElement_'+type
            }
        }
    }
};
</script>
